module.exports = __webpack_public_path__ + "static/media/connected.724fcb60.png";